import type { HttpValidationError } from "@/api-types";

export type ValidationError = HttpValidationError;

export const errorToString = (error: { msg: string; type: string }) => {
  switch (error.type) {
    case "string_pattern_mismatch":
      return `Value format doesn't look right`;
    default:
      return error.msg;
  }
};

export const validationErrors = (error: ValidationError) =>
  (error.detail || []).map((error) => ({
    field: error.loc.slice(1).join("."),
    message: errorToString(error),
    error,
  }));
